/**
 * Product Grid Slider - Swiper
 */

// Store swiper instances for cleanup
const swiperInstances = new Map();

function initSwiper(slider) {
  if (typeof Swiper === 'undefined') return;
  
  const sectionId = slider.dataset.sectionId;
  const config = JSON.parse(slider.dataset.swiperConfig || '{}');
  
  const {
    desktopColumns = 4,
    tabletColumns = 3,
    mobileColumns = 1.2,
    spaceBetween = 16,
    showPagination = false,
    autoRotate = 'disabled'
  } = config;

  const swiperConfig = {
    slidesPerView: parseFloat(mobileColumns),
    spaceBetween: spaceBetween,
    breakpoints: {
      750: { slidesPerView: parseFloat(tabletColumns) },
      990: { slidesPerView: parseFloat(desktopColumns) }
    },
    navigation: {
      prevEl: `.pgs-nav--prev[data-section="${sectionId}"]`,
      nextEl: `.pgs-nav--next[data-section="${sectionId}"]`
    }
  };

  if (showPagination) {
    swiperConfig.pagination = {
      el: `.pgs-pagination[data-section="${sectionId}"]`,
      clickable: true,
      dynamicBullets: true
    };
  }

  if (autoRotate !== 'disabled') {
    swiperConfig.autoplay = {
      delay: parseInt(autoRotate) * 1000,
      disableOnInteraction: true
    };
  }

  // Destroy existing instance if any
  if (swiperInstances.has(sectionId)) {
    swiperInstances.get(sectionId).destroy(true, true);
  }

  // Create new instance
  const swiperInstance = new Swiper(slider, swiperConfig);
  swiperInstances.set(sectionId, swiperInstance);
}

function initAllSliders() {
  const sliders = document.querySelectorAll('.pgs-slider');
  sliders.forEach(slider => initSwiper(slider));
}

// Initialize on load
document.addEventListener('DOMContentLoaded', initAllSliders);

// Reinitialize on theme editor changes
document.addEventListener('shopify:section:load', (event) => {
  try {
    const slider = event.target.querySelector('.pgs-slider');
    if (slider) {
      setTimeout(() => initSwiper(slider), 50);
    }
  } catch (e) {
    console.error('Error in section:load', e);
  }
});

document.addEventListener('shopify:section:unload', (event) => {
  try {
    const slider = event.target.querySelector('.pgs-slider');
    if (slider && slider.dataset.sectionId) {
      const sectionId = slider.dataset.sectionId;
      if (swiperInstances.has(sectionId)) {
        swiperInstances.get(sectionId).destroy(true, true);
        swiperInstances.delete(sectionId);
      }
    }
  } catch (e) {
    console.error('Error in section:unload', e);
  }
});
